import { useEffect } from 'react';
import { H3 } from 'UIComponents/elements/headings';
import UIButton from 'UIComponents/button/UIButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UITextInput from 'UIComponents/input/UITextInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { CountryDropdown } from '../components/CountryDropdown';
import RequestTypeLabel from '../components/RequestTypeLabel';
import Recaptcha from '../components/Recaptcha';
import { LanguageSelect } from './locales/LanguageSelect';
import LocaleFormattedMessage from './locales/LocaleFormattedMessage';
import LocaleFormattedJSXMessage from './locales/LocaleFormattedJSXMessage';
import useMediaQuery, { MEDIA_QUERY_BREAKPOINTS } from '../hooks/use-media-query';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function RequestForm({
  country,
  email,
  logoAltText,
  logoUrl,
  onChangeCountry,
  onChangeEmail,
  onChangeRecaptchaToken,
  onChangeRequestType,
  onSubmit,
  requestType,
  requestTypes,
  submitButtonDisabled,
  businessEmail,
  isRecaptchaEnabled,
  showCountrySetting
}) {
  const isMobile = useMediaQuery(MEDIA_QUERY_BREAKPOINTS.sm);
  useEffect(() => {
    if (requestTypes.length === 1) {
      onChangeRequestType(requestTypes[0]);
    }
  }, [onChangeRequestType, requestTypes]);
  return /*#__PURE__*/_jsx(UIFlex, {
    align: "center",
    direction: "column",
    children: /*#__PURE__*/_jsxs(View, {
      "data-test-id": "data-privacy-request-ui",
      marginBlock: isMobile ? '0' : '1200',
      paddingInline: isMobile ? '600' : '1400',
      paddingBlock: isMobile ? '600' : '1200',
      backgroundColor: "fill-surface-default",
      borderRadius: "200",
      children: [logoUrl && /*#__PURE__*/_jsx(Image, {
        alt: logoAltText,
        src: logoUrl,
        marginBlockEnd: "100",
        maxInlineSize: "100px",
        maxBlockSize: "200px"
      }), /*#__PURE__*/_jsx(LanguageSelect, {}), /*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.dataPrivacyRequest"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.dataPrivacyRequestDescription"
        })
      }), showCountrySetting === 'ENABLED_AND_ENFORCED' && /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.country.title"
        }),
        required: true,
        children: /*#__PURE__*/_jsx(CountryDropdown, {
          value: country,
          onChange: onChangeCountry
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.requestTypeDescription"
        }),
        required: true,
        children: /*#__PURE__*/_jsx(UIToggleGroup, {
          name: "request-type",
          children: requestTypes.map(_requestType => /*#__PURE__*/_jsx(UIRadioInput, {
            "data-test-id": `${_requestType}-radio`,
            onChange: () => onChangeRequestType(_requestType),
            checked: requestType === _requestType,
            children: /*#__PURE__*/_jsx(RequestTypeLabel, {
              requestType: _requestType
            })
          }, _requestType))
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.email"
        }),
        required: true,
        children: /*#__PURE__*/_jsx(UITextInput, {
          "data-test-id": "email-input",
          name: "email",
          value: email,
          onChange: e => onChangeEmail(e.target.value)
        })
      }), isRecaptchaEnabled && /*#__PURE__*/_jsx(Recaptcha, {
        onReceiveToken: onChangeRecaptchaToken
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "submit-button",
        className: "m-top-7",
        use: "primary",
        onClick: onSubmit,
        disabled: submitButtonDisabled,
        children: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.submit"
        })
      }), businessEmail && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "500",
        as: "div",
        children: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(LocaleFormattedJSXMessage, {
            message: "app.emailContentWithLink_jsx",
            options: {
              email: businessEmail,
              href: `mailto:${businessEmail}`
            },
            elements: {
              Link
            }
          })
        })
      })]
    })
  });
}
export default RequestForm;